import React, { useContext } from "react";
import "../../../styles/components/PricingPage/vsTableChart.scss";
import EncordLogotype from "../../../assets/images/EncordLogotype.svg";
import ModalContext from "../../../Contexts/openModal";
import BlueTickTableTurner from "../../../assets/icons/BlueTickTableTurner";
import { VsIcon } from "../../../assets/icons/DiagramMonetIcons/VsIcon";
import xss from "xss";

const TableTurner = ({ slice, location }) => {
  const tableTurner = slice?.props?.slice;
  const { toggleModal } = useContext(ModalContext);

  return (
    tableTurner?.length > 0 && (
      <section
        className={`relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl `}
        id="tableMonet"
      >
        <article className={`lg:mx-11 py-8 sm:pb-10 sm:pt-20`}>
          <div className="flex flex-col items-center justify-center gap-10 lg:gap-[50px]">
            <div className="flex flex-col items-center gap-5">
              <div
                role="heading"
                aria-level="2"
                dangerouslySetInnerHTML={{
                  __html: xss(tableTurner[0].primary?.title?.html),
                }}
                className="vs_strong_style text-purple-1100 font-manrope text-2.5xl sm:text-3.25xl font-semibold  leading-10 tracking-[-1.5px]"
              />
              <p className="text-sm font-normal text-center text-gray-600 font-inter sm:text-lg tracking-tighter_2 sm:tracking-tightest">
                {tableTurner[0].primary?.descriptor_text?.text}
              </p>
            </div>
            <div className="flex flex-col-reverse items-center mt-4 sm:flex-row">
              {/* VS Card */}
              <div className="flex flex-col bg-[#FAFAFA] rounded-[10px] border border-gray-1400 sm:mx-0 lg:max-w-full sm:max-w-[264px] w-full sm:w-auto">
                {" "}
                <p className="text-[13px] font-semibold py-2 sm:py-3 px-2.5 sm:px-4 border-b border-b-gray-1600 rounded-t-[10px] bg-gray-1600 text-gray-2500 font-manrope lg:text-xl -tracking-[0.325px] lg:-tracking-[0.495px]">
                  {tableTurner[0]?.primary?.block_title?.text}
                </p>
                <div className="p-2.5 sm:px-4 flex flex-col">
                  {tableTurner[0]?.items?.map((item, index) => (
                    <div
                      key={index}
                      dangerouslySetInnerHTML={{
                        __html: xss(item?.block_item?.html),
                      }}
                      className="max-w-[348px] text-xs font-normal -tracking-[0.3px] py-[7px] sm:py-3  itemsList_strong_weight last:border-b-0 text-gray-2700 font-inter lg:text-lg lg:-tracking-[0.44px]"
                    />
                  ))}
                </div>
              </div>
              <div className="block sm:hidden relative -mt-2.5 -mb-2 self-center">
                <VsIcon />
              </div>
              {/* Encord Card */}
              <div className="flex flex-col bg-[#fff] rounded-[10px] border-[1.188px] border-[#dadada] encord_box_table_turner_shadow sm:-ml-3.5 ease-in-out duration-500 hover:border-purple-1500">
                <div className="px-6 py-3 lg:py-5 bg-gray-2800 rounded-t-[10px] encord_logo_width">
                  <EncordLogotype />
                </div>
                <div className="pb-[3px] px-4 lg:px-6 flex flex-col last_border_bottom">
                  {tableTurner[1]?.items?.map((item, index) => (
                    <div className="flex items-center gap-2.5 lg:gap-3 last:border-b-0 border-b border-b-gray-1400">
                      <div className="shrink-0 w-[15px] h-[15px] lg:w-[24px] lg:h-[24px]">
                        <BlueTickTableTurner />
                      </div>
                      <div
                        key={index}
                        dangerouslySetInnerHTML={{
                          __html: xss(item?.block_item?.html),
                        }}
                        className="text-sm lg:text-xl font-normal flex-1 flex-wrap pt-1.5 pb-1 sm:py-3 lg:py-[18px] itemsList_strong_weight text-gray-2700 font-inter -tracking-[0.35px] lg:-tracking-[1px]"
                      />
                    </div>
                  ))}
                </div>
                {tableTurner[1]?.primary?.cta_linl?.url ? (
                  <a
                    href={tableTurner[1]?.primary?.cta_linl?.url}
                    className="flex items-center justify-center gap-2 group lg:gap-3 w-full py-3 sm:py-2.5 lg:py-[15px] px-4 bg-purple-1500 hover:bg-[#503AD9] text-white font-manrope text-base lg:text-2.5xl tracking-tighter font-semibold lg:tracking-tightest_6 rounded-b-[10px] z-10"
                  >
                    {tableTurner[1]?.primary?.cta_title?.text}
                    {/* <svg
                      className="w-[15px] h-[15px] lg:w-[24px] lg:h-[24px] transition-all ease-in-out duration-300 lg:opacity-0 lg:group-hover:opacity-100"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.50345 10.4102L13.7884 10.4102L7.63255 15.7539C7.53411 15.84 7.59387 16 7.72395 16L9.27962 16C9.34817 16 9.41321 15.9754 9.46419 15.9314L16.107 10.1676C16.1678 10.1148 16.2166 10.0496 16.25 9.9764C16.2835 9.90316 16.3008 9.82358 16.3008 9.74307C16.3008 9.66255 16.2835 9.58298 16.25 9.50973C16.2166 9.43649 16.1678 9.37129 16.107 9.31855L9.42551 3.51953C9.39915 3.49668 9.36751 3.48438 9.33411 3.48438L7.72571 3.48438C7.59563 3.48438 7.53587 3.64609 7.6343 3.73047L13.7884 9.07422L3.50345 9.07422C3.4261 9.07422 3.36282 9.1375 3.36282 9.21484L3.36282 10.2695C3.36282 10.3469 3.4261 10.4102 3.50345 10.4102Z"
                        fill="white"
                      />
                    </svg> */}
                  </a>
                ) : (
                  <button
                    type="button"
                    onClick={toggleModal}
                    className="flex items-center justify-center group gap-2 lg:gap-3 w-full py-3 sm:py-2.5 lg:py-[15px] px-4 bg-purple-1500 hover:bg-[#503AD9] text-white font-manrope text-base lg:text-2.5xl tracking-tighter font-semibold lg:tracking-tightest_6 rounded-b-lg z-10 transition-colors duration-500 ease-in-out"
                  >
                    {tableTurner[1]?.primary?.cta_title?.text}
                    {/* <svg
                      className="w-[15px] h-[15px] lg:w-[24px] lg:h-[24px] transition-all ease-in-out duration-300 lg:opacity-0 lg:group-hover:opacity-100"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.50345 10.4102L13.7884 10.4102L7.63255 15.7539C7.53411 15.84 7.59387 16 7.72395 16L9.27962 16C9.34817 16 9.41321 15.9754 9.46419 15.9314L16.107 10.1676C16.1678 10.1148 16.2166 10.0496 16.25 9.9764C16.2835 9.90316 16.3008 9.82358 16.3008 9.74307C16.3008 9.66255 16.2835 9.58298 16.25 9.50973C16.2166 9.43649 16.1678 9.37129 16.107 9.31855L9.42551 3.51953C9.39915 3.49668 9.36751 3.48438 9.33411 3.48438L7.72571 3.48438C7.59563 3.48438 7.53587 3.64609 7.6343 3.73047L13.7884 9.07422L3.50345 9.07422C3.4261 9.07422 3.36282 9.1375 3.36282 9.21484L3.36282 10.2695C3.36282 10.3469 3.4261 10.4102 3.50345 10.4102Z"
                        fill="white"
                      />
                    </svg> */}
                  </button>
                )}
              </div>
            </div>
          </div>
        </article>
      </section>
    )
  );
};

export default TableTurner;
